export const BackgroundEffects = () => (
  <div className="fixed inset-0 overflow-hidden pointer-events-none z-0">
    <div className="spotlight spotlight-1"></div>
    <div className="spotlight spotlight-2"></div>
    <div className="spotlight spotlight-3"></div>
  </div>
);
